import React from 'react';
import { Modal as AntdModal } from 'antd';
import { ModalProps } from 'antd/lib/modal';
import './Modal.less';

const Modal: React.FC<ModalProps> = ({ children, ...props }) => {
  return (
    <AntdModal className="t-modal" {...props}>
      {children}
    </AntdModal>
  );
};

export default Modal;
